const classes = {
	HIDDEN: "hidden",
	LOADING: "loading",
	DISABLED: "disabled",
	SELECTED: "selected",
};

const elements = {
	TAB_HEADERS: "#tab-headers",
};

export { classes, elements };
